import MetadataModelTemplate from "./MetadataModelTemplate";

export default MetadataModelTemplate;
